import { useCurrentAccount } from '@mysten/dapp-kit';

export const useAddress = () => {
  const currentAccount = useCurrentAccount();
  return currentAccount?.address;
};
